import { render, staticRenderFns } from "./DashboardAlerts.vue?vue&type=template&id=7e3d88f7"
import script from "./DashboardAlerts.vue?vue&type=script&lang=js"
export * from "./DashboardAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports